"use client";

import { PropertyDataV2 } from "commonModule/services/common";
import DestinationRow from "./DestinationRow";
import TravelAgentPropertyCard from "./TravelAgentPropertyCard";
const FeaturedPropertiesRow = ({
  properties
}: {
  properties: PropertyDataV2[];
}) => {
  if (!properties?.length) return null;
  return <DestinationRow title='Featured Properties' subtitle='' data-sentry-element="DestinationRow" data-sentry-component="FeaturedPropertiesRow" data-sentry-source-file="FeaturedPropertiesRow.tsx">
      {properties.map(property => <TravelAgentPropertyCard key={property._id} property={property} isLazy={false} />)}
    </DestinationRow>;
};
export default FeaturedPropertiesRow;